import { Box, Collapse, Stack, Text, useDisclosure } from '@chakra-ui/react'
import { faChevronDown, faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'

interface CollapsibleProps {
  title: string | (() => JSX.Element)
  body?: string | (() => JSX.Element)
  BodyElement?: React.FC
  defaultIsOpen?: boolean
}

export default function Collapsible({
  title,
  body,
  BodyElement,
  defaultIsOpen = false,
}: CollapsibleProps): ReactElement {
  if (body == null && BodyElement == null) {
    throw new Error('Must provide either body or BodyElement')
  }

  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen })

  return (
    <Box>
      <Stack direction="row" align="center" spacing="8px" cursor="pointer" onClick={onToggle}>
        {isOpen ? (
          <FontAwesomeIcon icon={faChevronDown} />
        ) : (
          <FontAwesomeIcon icon={faChevronRight} />
        )}
        {typeof title === 'string' ? <Text fontWeight="bold">{title}</Text> : title()}
      </Stack>
      <Collapse in={isOpen} animateOpacity>
        <Box pl="24px" mt={3}>
          {body != null ? typeof body === 'string' ? <Text>{body}</Text> : body() : null}
          {BodyElement != null ? <BodyElement /> : null}
        </Box>
      </Collapse>
    </Box>
  )
}
